import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Widget, WidgetComponent } from 'src/app/models/Widget';
import { SHARED_IMPORTS } from 'src/app/utils/other/standalone-import';
import { WidgetWrapperComponent } from './widget-wrapper/widget-wrapper.component';
import { WidgetUsersComponent } from '../widgets/widget-users/widget-users.component';

@Component({
  selector: 'app-widget-chooser',
  templateUrl: './widget-chooser.component.html',
  styleUrl: './widget-chooser.component.scss',
  standalone: true,
  imports: [SHARED_IMPORTS, WidgetWrapperComponent, WidgetUsersComponent]
})
export class WidgetChooserComponent {
  @Input() dashboard: Widget[] = [];

  @Output() selectedWidgetHasChanged = new EventEmitter<WidgetComponent>();

  selectedWidget: string = '';

  WidgetComponent = WidgetComponent;

  /**
   * Emits an event when the selected widget changes.
   *
   * @param {WidgetComponent} widget - The name of the selected widget.
   * @returns {void}
   */
  widgetSelectedChange(widget: WidgetComponent): void {
    this.selectedWidgetHasChanged.emit(widget);
  }
}
